import { environment } from 'src/environments/environment';

export const StorageModel = {
    LAYOUT_CONFIG_VERSION_UPDATE: 'layout_config_version_updated',
    LAYOUT_CONFIG_LOCAL_STORAGE_KEY: `layout_config_${environment.VERSION}`
}
